import Patrol from "../fragments/patrol";

export default `
mutation DeletePatrolMedia($reportId: ID!, $mediaId: ID!) {
  deletePatrolMedia(reportId: $reportId, mediaId: $mediaId) ${Patrol}
}
`;
